import React, { useState } from "react";

import Header from "../../layout/Header";
import Subheader from "../../layout/Subheader";

import useStyles from "./style";
import { Link } from "react-router-dom";
import {
  calcLengthBtnMenu,
  getURL,
  getUrlControle
} from "../../services/auth";

export function Registers() {
  const classes = useStyles();
  const { menus } = JSON.parse(sessionStorage.getItem('@Capitalle-Menu'));
  const [largerItemLenght, setLargerItemLenght] = useState(0);

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title='Cadastros' />
      <div className={classes.content}>
        <div className={classes.contentHome}>
          {menus.map((menu) => (
            <>
              {menu.controle == 3 && (
                <Link
                  to={
                    menu.acao == "ProximoControle" || menu.acao == "ControleAnterior" ? getUrlControle(menu.irParaControle) : 
                    menu.acao == "CarregaUrl" ? getURL(menu.moduloId) : '#'}
                  className={classes.cardLink}
                  style={{ width: calcLengthBtnMenu(menu.titulo, setLargerItemLenght, largerItemLenght), backgroundColor: menu.corFundo }}>
                  <span className={classes.cardLinkText} style={{ color: menu.corFonte }}>{menu.titulo}</span>
                </Link>                
              )}
            </>
          ))}
          {/* {!!findSomePermission(711, "Cadastrar") && (
            <Link
              to={getURL("ancoras")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(711), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(711)}</span>
            </Link>
          )}
          {!!findSomePermission(1344, "Cadastrar") && (
            <Link
              to={getURL("colaboradores")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1344), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1344)}</span>
            </Link>
          )}
          {!!findSomePermission(1247, "Cadastrar") && (
            <Link
              to={getURL("fornecedores")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1247), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1247)}</span>
            </Link>
          )}

          {!!findSomePermission(1887, "Cadastrar") && (
            <Link
              to={getURL("grupoFornecedores")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1887), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1887)}</span>
            </Link>
          )}

          {!!findSomePermission(1364, "Consultar") && (
            <Link
              to={getURL("cartoesPonto")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1364), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1364)}</span>
            </Link>
          )}
          {!!findSomePermission(1146, "Consultar") && (
            <Link
              to={getURL("plataformas")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1146), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1146)}</span>
            </Link>
          )} */}
        </div>
      </div>
    </div>
  );
}
